import {Component, computed, inject, signal} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgbAlert} from '@ng-bootstrap/ng-bootstrap';
import {EmailConfirmIconComponent} from '@core/svg-icons/email-confirm-icon.component';
import {LoadingComponent} from '@layout/components/general/loading/loading.component';
import {UserService} from '@core/services/user.service';
import {SadWineglassIconComponent} from '@layout/components/general/sad-wineglass-icon/sad-wineglass-icon.component';

@Component({
  selector: 'app-account-not-confirmed-modal',
  templateUrl: './account-not-confirmed-modal.component.html',
  styleUrls: ['./account-not-confirmed-modal.component.scss'],
  imports: [
    ModalContainerComponent,
    EmailConfirmIconComponent,
    LoadingComponent,
    SadWineglassIconComponent,
    NgbAlert
  ]
})
export class AccountNotConfirmedModalComponent {
  private userService = inject(UserService);


  email = computed(() => this.userService.userSignal()?.emailForOrderConfirmation);
  hasSendEmail = signal(false);
  loading = signal(false);

  sendConfirmationEmail() {
    const email = this.email();
    if (!email) {
      console.error('No email!');
      return;
    }
    this.loading.set(true);
    this.userService.sendEmailConfirmation(email).then(x => {
      this.loading.set(false);
      this.hasSendEmail.set(true);
    }).catch(() => {
      this.loading.set(false);
    });
  }

}
